import { AlertAction } from '@/components/ui/alert';
import { ConfirmEmailActionProps } from './types';
import { MailCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const getEmailParts = (email: string): { domain: string; local: string } | null => {
  const atIndex = email.lastIndexOf('@');

  if (atIndex <= 0 || atIndex === email.length - 1) return null;

  return {
    domain: email.slice(atIndex + 1),
    local: email.slice(0, atIndex + 1)
  };
};

const ConfirmEmailAction = (props: ConfirmEmailActionProps) => {
  const {
    email
  } = props;

  const navigate = useNavigate();
  const normalizedEmail = email?.trim();
  const emailParts = normalizedEmail ? getEmailParts(normalizedEmail) : null;
  const hint = normalizedEmail ? (
    <>
      Письмо отправлено на{' '}
      {emailParts ? (
        <span className="inline-flex max-w-full align-bottom">
          <span className="min-w-0 truncate">{emailParts.local}</span>
          <span className="shrink-0 whitespace-nowrap">{emailParts.domain}</span>
        </span>
      ) : (
        <span className="break-all">{normalizedEmail}</span>
      )}
      {' '}
      — отправить снова можно в профиле.
    </>
  ) : (
    'Письмо отправлено на электронную почту — отправить снова можно в профиле.'
  );

  const onClickButton = (): void => {
    navigate('/profile/edit');
  };

  return (
    <AlertAction
      className="hover:!bg-accent-soft active:!bg-accent-soft"
      hint={hint}
      hintClassName="whitespace-normal text-clip"
      icon={<MailCheck className="size-5" strokeWidth={1.75} />}
      label="Подтвердите электронную почту"
      onClick={onClickButton}
    />
  );
};

export default ConfirmEmailAction;